import RestResource from '../rest.service';
import Service from '../api.service';

export default class ReceiptsService extends RestResource {
  map(payload) {
    const conceptPayments = payload.conceptPayments.map((conceptPayment) => {
      return {
        concept_payment_type_id: conceptPayment.conceptPaymentType.id,
        amount_in_dollars: conceptPayment.amountInDollars,
        amount_in_pesos: conceptPayment.amountInPesos,
        bank: conceptPayment.bank,
        postal_code: conceptPayment.postalCode,
        number: conceptPayment.number,
        accreditation_date: conceptPayment.accreditationDate,
      };
    });

    return {
      dollar_quotation: payload.dollarQuotation,
      number: payload.number,
      concept_payments: conceptPayments,
      order_id: payload.orderId,
    };
  }

  confirm(id) {
    return Service.post(`${this.getResource({ id })}/confirm`).catch(this.handleErrors);
  }

  constructor() {
    super('receipts');
  }
}
